import { createFileRoute, redirect } from '@tanstack/react-router'

import { cachedCan } from '@/features/auth/session'
import { NewVehicle } from '@/features/vehicles/new-vehicle'

export const Route = createFileRoute('/_app/vehicles/new')({
  // `_app` has already put the profile in the cache and selected a dealership: a member who
  // cannot add stock is sent to the list before the form ever renders.
  beforeLoad: ({ context }) => {
    if (!cachedCan(context.queryClient, 'sell')) throw redirect({ to: '/vehicles', replace: true })
  },
  component: NewVehicle,
})
